


















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import useBreakpoint from '@shared/composables/useBreakpoint';

import CardSectionView from './CardSectionView.vue';
import useFlattenedConfig from './internal/useFlattenedConfig';
import useStyles from './internal/useStyles';
import useVisibility from './internal/useVisibility';
import { PartialConfig } from './types';

export default defineComponent({
  name: 'CardSection',
  components: {
    CardSectionView,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: [String, Object],
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    mobile: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
    tablet: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
    desktop: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { globalConfig } = useBrandConfig();
    const { breakpoint } = useBreakpoint();
    const { config } = useFlattenedConfig(props, breakpoint);
    const { styles } = useStyles(config, globalConfig, breakpoint);
    const { showDescription, showHeaderText, showSteppers, showHeaderActions, showHeader } =
      useVisibility(props, config);

    return {
      showHeader,
      showHeaderText,
      showHeaderActions,
      showDescription,
      showSteppers,
      styles,
    };
  },
});
